import React, { useEffect } from 'react';
import { navigateTo } from 'utilities/Utils';
import { routes } from '../../../app/routes';
import { Button } from '../../../components/new-core';

import { useRTBPendingBookings } from 'shared_logic';
import { getFormattedDate } from '../../../utilities/DateUtils';
import { getExpiryTime } from '../../guest-chat/GuestChatUtils';

import { legacyPushToGTM, GTM_CATEGORIES, pushToOmniture } from 'utilities/gtm';
import { goibiboIcon, makeMyTripIcon } from 'assets/common';
import { ExpireTimerIcon } from 'assets/modules/dashboard';
import { actualDomainNames } from 'shared_logic/constants';
import { doMonthFormat } from 'constants';
import { OMNITURE_CATEGORIES } from 'utilities/gtm';
const gtmAction = 'rtb_requests';

function RTBPendingDashboardPersuasion(props) {
  const { STRINGS, onSectionLoadUpdate, gtmLabel } = props;
  const N_STRINGS = STRINGS.RTB_PENDING_BKGS;
  const { pendingRequestsData } = useRTBPendingBookings();

  let noOfBkgRequests = 0;
  let firstPendingBooking = {};

  if (pendingRequestsData.showPersuasion) {
    noOfBkgRequests = pendingRequestsData.data.count;
    firstPendingBooking = pendingRequestsData.data.persuasions[0].data;
  }

  const handleViewAll = label => {
    pushToOmniture({
      event: OMNITURE_CATEGORIES.CTA_CLICK,
      cta: {
        name: `rtb_${label}`,
        type: 'click',
        componentName: 'rtb_requests',
      },
    });
    navigateTo(routes.guestchat.bookingRequest);
  };

  const profileLogo =
    firstPendingBooking.vendor === actualDomainNames.MMT
      ? makeMyTripIcon
      : goibiboIcon;

  useEffect(() => {
    if (!Object.keys(pendingRequestsData).length) {
      return;
    }
    if (pendingRequestsData.showPersuasion) {
      legacyPushToGTM({
        eventCategory: GTM_CATEGORIES.DASHBOARD_OPPORTUNITIES,
        eventAction: gtmAction,
        eventLabel: `requests__${pendingRequestsData.data.count}`,
      });
      onSectionLoadUpdate(true, gtmLabel);
    } else {
      onSectionLoadUpdate(false, gtmLabel);
    }
  }, [pendingRequestsData]);

  if (!pendingRequestsData.showPersuasion) {
    return null;
  }

  return (
    <div className="sr-panel">
      <div className="sr-panel-heading d-flex sr-align-center">
        <div className="font16 sr-flex1 text-gray">
          {N_STRINGS.TITLE.replace('__noOfBkgRequests__', noOfBkgRequests)}
        </div>
        <div>
          <Button onClick={() => handleViewAll('view_all')}>
            {N_STRINGS.VIEW_ALL}
          </Button>
        </div>
      </div>
      <div className="sr-panel-body sr-flex-row pad20">
        <div className="sr-flex-row font16 sr-flex1">
          <div className="padR8">
            <img src={profileLogo} alt="profile-logo" width="36" height="36" />
          </div>
          <div>
            <p className="margin0 font14 fw500 break-all">
              {firstPendingBooking.guest_name}
            </p>
            <div className="font11 fw500">
              <span className="fw500 text-gray">
                {`${getFormattedDate(
                  new Date(firstPendingBooking.checkin),
                  doMonthFormat,
                )} - ${getFormattedDate(
                  new Date(firstPendingBooking.checkout),
                  doMonthFormat,
                )}`}
              </span>
              <span className="padLR5 text-gray">
                &#9679;
                {` ${firstPendingBooking.currency} ${firstPendingBooking.booking_amount}`}
              </span>
              <span>
                <img
                  width="12"
                  height="12"
                  src={ExpireTimerIcon}
                  alt="expired-timer"
                />
                <span className="font10 padL2 red">{`${
                  N_STRINGS.EXPIRES
                } ${getExpiryTime(firstPendingBooking.expiry_time)}`}</span>
              </span>
            </div>
          </div>
        </div>
        <div className="ml-4">
          <Button
            className="marginR10"
            variant="outlined"
            onClick={() => handleViewAll('decline')}
          >
            {N_STRINGS.DECLINE}
          </Button>
          <Button onClick={() => handleViewAll('approve')}>
            {N_STRINGS.APPROVE}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default RTBPendingDashboardPersuasion;
